export const defaultSearchConfig = {
  filtersSupported: true,
  showSearchSupported: true,
  searchShowAllSupported: true,
  showTopicsSupported: true
};